import { FC, useState } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import styled from './index.module.scss';
import CheckedIcon from './Icon';
import EndWin from './EndWin';
import Emarsys from '@/components/MembersDay/FY2024/Emarsys';
import { EU_SITES, finishedSource } from '@/constants/membersday';
import getLocal from '@/app/utils/getLocal';
import gtm from '@/utils/gtm';
import { useLang } from '@/i18n';
import { getPrivacyPolicy } from '@/utils/common';

const hasCheckBoxLocal = ['za', 'au', 'kr'].concat(EU_SITES);

const Subscribe: FC = ({}) => {
    const { locale } = getLocal();
    const { t } = useLang('membersday.subscribe');
    const [checked, setChecked] = useState(locale === 'za' || EU_SITES.includes(locale) ? false : true);
    const [showWin, setShowWin] = useState(false);

    const successCallBack = () => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('btnText'),
                status: 'success',
                tag: 'Agree',
            });
            setShowWin(true);
        } catch (e) {
            console.error(e);
        }
    };

    const errorCallback = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_submit',
            button_name: t('btnText'),
            status: 'fail',
            tag: 'Agree',
        });
    };

    // 关闭
    const closeCallback = () => {
        setShowWin(false);
    };

    return (
        <div className={styled.Subscribe}>
            <EditorImg
                pc={'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1710667257193/Sign%20upjpg.jpg'}
                h5="https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1710667308935/Sign%20upjpg.jpg"
                alt={''}
            />

            <div className="subscribe_box">
                <h5 className="subscribe_title">{t('title_end') || t('title')}</h5>
                <div className="email-box">
                    <Emarsys
                        hideTips
                        source={finishedSource}
                        submitText={t('btnText')}
                        placeholder={t('placeholder_end') || t('placeholder')}
                        successCallback={successCallBack}
                        errorCallback={errorCallback}
                        checked={checked}
                    />
                    <p className="protocol">
                        {hasCheckBoxLocal.includes(locale) && (
                            <span className={`check ${checked && 'checked'}`} onClick={() => setChecked(!checked)}>
                                {checked && <CheckedIcon />}
                            </span>
                        )}
                        {t.rich('protocol', {
                            line1: (text: string) => {
                                const defaultUrl = getPrivacyPolicy(locale);
                                const linkMap: Record<string, string> = {
                                    jp: 'https://account.ecoflow.com/agreement/ja-jp/PrivacyPolicy.html',
                                };
                                const link = linkMap[locale] ? linkMap[locale] : defaultUrl;
                                return (
                                    <a className="link" href={link} target="_blank" rel="noreferrer">
                                        {text}
                                    </a>
                                );
                            },
                            line2: (text: string) => {
                                const defaultUrl = `https://${locale}.ecoflow.com/policies/terms-of-service`;
                                const linkMap: Record<string, string> = {
                                    jp: 'https://account.ecoflow.com/agreement/ja-jp/TermsOfUse.html',
                                };
                                const link = linkMap[locale] ? linkMap[locale] : defaultUrl;
                                return (
                                    <a className="link" href={link} target="_blank" rel="noreferrer">
                                        {text}
                                    </a>
                                );
                            },
                        })}
                    </p>
                </div>
            </div>
            {showWin && <EndWin callback={closeCallback} />}
        </div>
    );
};

export default Subscribe;
